// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const STROLLER_ADDQUESTION_HEADING = "Zeptej se";
export const STROLLER_QUESTIONS_AND_ANSWERS = "Ot\u00e1zky a odpov\u011bdi";
